import React, { useState, type FC } from 'react'
import svgPlay from '../assets/play.svg'
import { motion } from 'framer-motion'

interface IProps {
  cover: IQuestion['cover']
  index: number
  questionsLength: number
  minutes: string
  seconds: string
}

const Cover: FC<IProps> = ({ cover, index, questionsLength, minutes, seconds }) => {
  const { type, image, video, videoYt } = cover

  const [removePoster, setRemovePoster] = useState(false)

  const handleOnClick = (): void => {
    setRemovePoster(true)
  }
  return (
    <div className='flex justify-center items-center'>
      <div className='relative mx-8 mb-8'>
        <div className='z-30 h-20 w-20 absolute bottom-0 left-0 translate-y-10 flex justify-center items-center rounded-full bg-[#FBF8F6] lg:h-32 lg:w-32 lg:-top-16 lg:left-1/2 lg:-translate-x-1/2 lg:translate-y-0'>
          <span className='flex flex-col lg:flex-row'>
            <span className='text-xl lg:text-2xl leading-[110%]'>{index + 1}</span>
            <span className='leading-[110%]'>/{questionsLength}</span>
          </span>
        </div>
        <div className='absolute -bottom-8 right-0 lg:hidden'>
          {minutes}:{seconds}
        </div>
        {type === 'video' && (
          <video
            className='w-full h-full object-cover max-w-3xl'
            src={video}
            loop
            muted
            controls
          />
        )}
        {type === 'image' && (
          <img
            className='w-full h-full object-cover max-w-3xl'
            src={image}
            alt='cover'
          />
        )}
        {type === 'videoYt' && (
          <div className='relative'>
            <div
              dangerouslySetInnerHTML={{
                __html: videoYt.video,
              }}
              className='videoYt cursor-pointer max-w-3xl'
            />
            <motion.img
              animate={removePoster && { opacity: 0, transitionEnd: { display: 'none' } }}
              className='absolute top-0 left-0 w-full h-full object-cover max-w-3xl cursor-pointer'
              src={videoYt.poster}
              alt='cover'
              onClick={handleOnClick}
            />
            <motion.img
              animate={removePoster && { opacity: 0, transitionEnd: { display: 'none' } }}
              className='absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 cursor-pointer'
              src={svgPlay}
              alt='play'
              onClick={handleOnClick}
            />
          </div>
        )}
      </div>
    </div>
  )
}

export default Cover
